export function updateMenuButton() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');
  const toggleAttributes = { tabindex: '0', role: 'button', 'aria-label': 'Toggle mobile menu' };

  createMenuButtons();
  bindOpenToggleKeyboard();

  function createMenuButtons() {
    currentToggle.attr(toggleAttributes).append(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
      <!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
        <path d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/>
      </svg>
    `);

    closeToggle.attr(toggleAttributes).append(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
      <!--!Font Awesome Pro 7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.-->
        <path d="M182.9 137.4L160.3 114.7L115 160L137.6 182.6L275 320L137.6 457.4L115 480L160.3 525.3L320.3 365.3L457.6 502.6L480.3 525.3L525.5 480L502.9 457.4L365.5 320L502.9 182.6L525.5 160L480.3 114.7L457.6 137.4L320.3 274.7L182.9 137.4z"/>
      </svg>
    `);
  }

  function bindOpenToggleKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        bindCloseToggleKeyboard();
      }
    });
  }

  function bindCloseToggleKeyboard() {
    closeToggle.attr(toggleAttributes).focus();
    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

export function setNavItemAttributes() {
  $('#mainNavigation .groups .group').each(function () {
    const $group = $(this);

    if ($group.attr('aria-haspopup') === 'true') {
      $group.children('a.showingNav').attr('tabindex', '0');
    }

    if (
      $group.attr('aria-haspopup') === 'false' &&
      $group.children('a.showingNav').attr('href') == undefined
    ) {
      $group.children('a.showingNav').parent().addClass('no-link');
    }
  });
}
